import locale from "common/managers/locale";

export default {
    format: function(bytes) {
        const unit = 1024;
        let ret = "";
        if (!bytes) {
            bytes = 0;
        }

        if (bytes < unit) {
            ret = locale.get("bytes", bytes);
        } else {
            const log = Math.floor(Math.log(bytes) / Math.log(unit)),
                val = kendo.toString(bytes / Math.pow(unit, Math.min(log, 3)), "n1");

            // we support up to GB for now.
            if (log === 1) {
                ret = locale.get("kbs", val);
            } else if (log === 2) {
                ret = locale.get("mbs", val);
            } else {
                ret = locale.get("gbs", val);
            }
        }
        return ret;
    }
}
